module.exports = __webpack_public_path__ + "static/media/donationBackground.bea52d9f.jpg";